<template>
  <div>
    <support-modal
      :modal-id="supportModalId"
      :support="support"
      :support-categories="supportCategories"
      @submit-support-modal="sendSupport"
    />
    <preloader @hide-preloader="loadData"/>
    <b-navbar toggleable="lg" type="light" fixed="top" id="header">
      <div class="container">
        <template v-if="isAuthorized">
          <b-navbar-brand to='/' class="logo">
            <img src="../../public/img/logo.png" alt="logo" class="img-logo pull-left"/>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
<!--              <b-nav-item class="active-applications"-->
<!--                          v-if="visibleApplicationArchiveLink"-->
<!--                          :href="applicationArchiveUrl"-->
<!--              >Архив заявок-->
<!--              </b-nav-item>-->
              <b-nav-item class="active-applications"
                          v-if="visibleGuardScreenLink"
                          :href="guardScreenUrl"
              >Посетители
              </b-nav-item>

              <user-menu-item :links="menuLinks" />
            </b-navbar-nav>
          </b-collapse>
        </template>
      </div>
    </b-navbar>
    <div class="main-container">
      <slot/>
    </div>
    <div class="container">
      <div class="row" style="padding-bottom: 30px">
        <div class="col-lg-6 col-xs-6">
          <div style="color: #aaa; margin-bottom: 10px">Оператор сервиса:</div>
          <img
            src="../../public/img/konversta.png"
            alt
            style="display: block; width: 150px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from '../common/components/Preloader.vue'
import UserMenuItem from '../common/components/UserMenuItem.vue'
import ApiClient from '@/helpers/api-client/ApiClient'
import mainMixin from '../common/mixins/mainMixin'
import { UserRoles } from '@/enums/UserRoles'
import SupportModal from '../common/components/SupportModal'
import { Logger } from '@/common/helpers/Logger'
import { ResponseStatuses } from '@/enums/ResponseStatuses'
import { cloneObject } from '@/common/helpers'

export default {
  name: 'MainLayout',

  components: {
    Preloader,
    UserMenuItem,
    SupportModal
  },
  mixins: [mainMixin],

  data: () => {
    const defaultSupport = {
      sending: false,
      form: {
        category_id: null,
        theme: null,
        message: null
      },
      errors: []
    }

    return {
      applicationScreenCounter: null,
      supportModalId: 'support-modal',
      supportCategories: [],
      defaultSupport,
      support: cloneObject(defaultSupport)
    }
  },

  computed: {
    guardScreenUrl () {
      return ApiClient.getGuardScreenUrl()
    },

    menuLinks () {
      return [
        {
          label: 'Список заявок',
          visible: true,
          onClick: () => this.$router.push({ name: 'application-list' })
        },
        {
          label: 'Панель администратора',
          visible: this.user && [UserRoles.ADMIN, UserRoles.CEO].includes(this.user.role),
          url: ApiClient.getAdminPanel()
        },
        {
          label: 'Личный кабинет',
          visible: true,
          url: ApiClient.getAccountUrl()
        },
        {
          label: 'Поддержка',
          visible: true,
          onClick: this.onClickSupportLink
        }
      ]
    },

    visibleApplicationScreenLink () {
      return true // this.user && this.user.role !== UserRoles.GUARD
    },

    visibleBlacklistScreenLink () {
      return (
        this.user &&
        [UserRoles.SB_SUBDIVISION, UserRoles.SB_BLACKLIST].includes(
          this.user.role
        )
      )
    },

    visibleBulletinLink () {
      return (
        this.user &&
          this.user.role === UserRoles.SB
      )
    },

    visibleGuardScreenLink () {
      return this.user && this.user.role === UserRoles.GUARD
    },

    visibleVisitorScreenLink () {
      return (
        this.user &&
        [UserRoles.SB, UserRoles.SB_TRUCK, UserRoles.SB_OTHER, UserRoles.SUPERVISOR].includes(
          this.user.role
        )
      )
    }
  },

  methods: {
    async loadData () {
      if (!this.user) {
        return
      }

      await ApiClient.mainHeaderData().then((response) => {
        const responseData = response.data

        if (!responseData.data) {
          return
        }

        this.applicationScreenCounter =
          responseData.data.applicationScreenCounter

        this.supportCategories = responseData.data.supportCategories
      })
    },

    onClickSupportLink () {
      this.$bvModal.show(this.supportModalId)
    },

    async sendSupport () {
      Logger.log('Sending support message...')
      this.support.sending = true

      await ApiClient.sendSupport(this.support.form).then(response => {
        this.support.sending = false
        const result = response.data

        if (result.status === ResponseStatuses.Success) {
          this.$bvModal.hide(this.supportModalId)
          this.support = cloneObject(this.defaultSupport)
          Logger.log('Successfully sent support message...')
        } else {
          this.support.errors = result.errors
          Logger.log('Error while sending support message...')
        }
      })
    }
  },

  metaInfo: {
    title: 'Сервис по оформлению заявок на пропуск'
  }
}
</script>
